import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GridComponent } from '@progress/kendo-angular-grid';
import * as _ from 'lodash';
import { forkJoin, Subscription } from "rxjs";
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { ServicesApiService } from 'src/app/services/services-api.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';
import { QuotesService } from 'src/app/quotes/quotes.service';
import { JobsService } from 'src/app/jobs/jobs.service';

const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};
@Component({
    selector: "app-orders-services-list",
    templateUrl: "./orders-services-list.component.html",
    styleUrls: ["./orders-services-list.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class OrdersServicesListComponent
    extends AppComponentBase
    implements OnInit, OnDestroy {
    componentSubscriptions: Subscription = new Subscription();
    @Input() isPanelExpended: boolean;
    @Input() readOnly: boolean;
    @Output() emitUpdateServices: EventEmitter<any> = new EventEmitter();

    @ViewChild("grid", { static: true }) private grid: GridComponent;
    @ViewChild("serviceForm", { static: true }) serviceForm: NgForm;
    // origin account
    @Input() set originAccountParam(account: any) {
        if (account.accountId) {
            this.accountId = account.accountId;
            this.getDefaultServices(true);
        } else {
            this.onReomveDefaultService(1);
        }
    }
    // destination account
    @Input() set destAccountParam(account: any) {
        if (account.accountId) {
            this.accountId = account.accountId;
            this.getDefaultServices(false);
        } else {
            this.onReomveDefaultService(2);
        }
    }

    @Input() set servicesParams(data: any) {
        if (data && data.length > 0) {
            this.services = data;
            this.getDefaultServices(false);
            this.getServiceType();
        }
    }

    @Input() set fromDistanceInMiles(data: any) {
        if (data) {
            this.fromDistance = data;
            if (this.activatedRoute.snapshot.queryParams.jobId) {
                this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
                this.onSetPickupQuantity();
            } else if (this.activatedRoute.snapshot.queryParams.quoteId) {
                this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
                this.onSetPickupQuantity();
            } else {
                this.onSetPickupQuantity();
            }
        } else {
            this.fromDistance = null;
            this.onSetPickupQuantity();
        }
    }

    commmonDataModel = new CommonDataModel();
    fromDistance: any;
    orderId: any;
    categories: any;
    revenueCategories: any;
    serviceDataCopy: any;
    editedRowIndex: number;
    docClickSubscription: any;
    totalSubTotal: any;
    totalValue: any;
    taxTotal: any;
    markUpTotal: any;
    accountId: number;
    services: any;
    serviceData: any;
    autoPopulateAccountId: any;
    gridItems: any = {
        data: [],
        total: 0,
    };
    frenchiseDistaceQty: any;
    isAccountPopulateDisabled: boolean = false;
    isTaxColumnVisible: boolean = false;
    orderData: any;

    constructor(
        injector: Injector,
        private activatedRoute: ActivatedRoute,
        private servicesApiService: ServicesApiService,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        private renderer: Renderer2,
        private quotesService: QuotesService,
        private jobsService: JobsService,
    ) {
        super(injector);
        this.renderer.listen("document", "click", ({ target }) => {
            if (!isChildOf(target, "serviceGrid")) {
                if (this.serviceForm.valid) {
                    this.grid.closeRow(this.editedRowIndex);
                    this.editedRowIndex = null;
                }
            }
        });
        this.gridItems = {
            data: [],
            total: 0,
        };
    }

    ngOnInit(): void {
        this.componentSubscriptions.add(
            this.commonMethod.getAutoPopulateAccountId.subscribe((data) => {
                if (data && data != 0) {
                    this.autoPopulateAccountId = data;
                    this.isAccountPopulateDisabled = false;
                } else {
                    this.autoPopulateAccountId = '0';
                    this.isAccountPopulateDisabled = true;
                }
            })
        );
        this.loadItems();
    }

    loadItems(): void {
        forkJoin([
            this.servicesApiService.getCategories(),
            this.servicesApiService.getServiceLookup(),
            this.servicesApiService.getRevenueCategories(),
        ]).subscribe(
            ([categories, serviceData, revenueCategories]) => {
                if (categories.isSuccess) {
                    this.categories = categories.data;
                }

                if (serviceData.isSuccess) {
                    this.serviceDataCopy = serviceData.data;
                    this.serviceData = serviceData.data;
                    if (this.gridItems.data) {
                        this.gridItems.data.forEach((item, index) => {
                            this.mappingServiceDropDownData(
                                item.revenueCategoryId,
                                index
                            );
                            if (item.isTaxable && item.taxPercentage) {
                                this.commonMethod.sendIsTaxable(item.isTaxable);
                            }
                        });
                    }
                }

                if (revenueCategories.isSuccess) {
                    this.revenueCategories = revenueCategories.data;
                }
            },
            (error) => {
                console.error("Error loading data", error);
            }
        );
        if (!this.activatedRoute.snapshot.queryParams.jobId && !this.activatedRoute.snapshot.queryParams.quoteId) {
            this.onPopulateAccountService(false);
        }
        this.onGetOrderDetailsAccount();
    }

    onSetPickupQuantity() {
        if (this.readOnly) return;

        this.gridItems.data.map((item) => {
            const serviceName =
                item && item.serviceName
                    ? item.serviceName.trim().toLowerCase()
                    : "";
            const index = serviceName.indexOf("pickup");
            const updatedQty = parseInt(
                this.commonService.getLocalStorage("pickupQty")
            );
            const isPickupModified =
                this.commonService.getLocalStorage("isPickupModified");
            if (index !== -1) {
                this.frenchiseDistaceQty = this.fromDistance
                    ? Math.ceil(this.fromDistance * 2)
                    : item.quantity;
                if (isPickupModified) {
                    item.quantity = updatedQty;
                    item.isPickupQuantityChanged = true;
                } else if (item.isPickupQuantityChanged) {
                    item.quantity = item.quantity;
                } else {
                    item.quantity = this.frenchiseDistaceQty;
                    item.isPickupQuantityChanged = false;
                }
                this.onCalulateServiceRow(item);
            }
        });
    }

    onCalulateServiceRow(item: any) {
        this.calculateSubTotal(item);
        this.calculateMarkup(item);
        this.calculateTotal(item);
        this.onCalculateTotals();
    }

    getDefaultServices(isOrigin: any): void {
        if (this.services) {
            this.services.forEach(service => {
                service.serviceTypeDataSource = [];
                if (service.isTaxable) {
                    this.commonMethod.sendIsTaxable(service.isTaxable);
                }
            });
            this.gridItems.data = [];
            this.services.forEach(service => {
                const exists = this.gridItems.data.some(item => item.orderServiceId === service.orderServiceId);
                if (!exists || !service.orderServiceId) {
                    this.gridItems.data.push(service);
                }
            });
            this.gridItems.data = _.uniqBy(this.gridItems.data, 'orderServiceId');
            this.services = null;
            this.onCalculateTotals();
        } else {
            this.removeGridRecords(isOrigin);
            this.totalSubTotal = null;
            this.totalValue = null;
            this.taxTotal = null;
            this.markUpTotal = null;
        }
    }

    onGetOrderDetailsAccount(): void {
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.jobsService.getJob(this.activatedRoute.snapshot.queryParams.jobId).subscribe(response => {
                this.setTaxColumnVisibility(response.data);
            });
        } else if (this.activatedRoute.snapshot.queryParams.quoteId) {
            this.quotesService.getQuote(this.activatedRoute.snapshot.queryParams.quoteId).subscribe(response => {
                this.setTaxColumnVisibility(response.data);
            });
        }
    }

    setTaxColumnVisibility(data: any): void {
        this.orderData = data;
        if (data.createdDate && data.newTaxConfigAppliedDate) {
            const createdDate = new Date(data.createdDate);
            const newTaxConfigAppliedDate = new Date(data.newTaxConfigAppliedDate);
            this.isTaxColumnVisible = newTaxConfigAppliedDate >= createdDate;
            this.commonMethod.sendIsTaxColumnVisible(this.isTaxColumnVisible);
        } else {
            this.isTaxColumnVisible = false;
            this.commonMethod.sendIsTaxColumnVisible(this.isTaxColumnVisible);
        }
    }

    onPopulateAccountService(isAutoPopulate: boolean): void {
        if (this.autoPopulateAccountId) {
            this.servicesApiService.getAccountMappedService(this.autoPopulateAccountId, isAutoPopulate).subscribe(response => {
                if (response.data && response.data.services && response.data.services.length > 0) {
                    const newServices = response.data.services.map(service => ({
                        ...service,
                        byAccount: true,
                        serviceTypeDataSource: []
                    }));
                    newServices.forEach(service => {
                        const exists = this.gridItems.data.some(item => item.serviceId === service.serviceId);
                        if (!exists) {
                            this.gridItems.data.push(service);
                        }
                    });
                    if (isAutoPopulate) {
                        this.isAccountPopulateDisabled = true;
                        this.serviceForm.form.markAsDirty();
                        this.emitUpdateServices.emit();
                    }
                    this.gridItems.data.forEach((list, index) => {
                        this.mappingServiceDropDownData(list.revenueCategoryId, index);
                    });
                    this.onSetPickupQuantity();
                }
            });
        }
    }

    getCategories(): void {
        this.servicesApiService.getCategories().subscribe((response) => {
            if (response.isSuccess) {
                this.categories = response.data;
            }
        });
    }

    getServiceType(): void {
        this.servicesApiService.getServiceLookup().subscribe(response => {
            this.serviceDataCopy = response.data;
            this.serviceData = response.data;
            if (this.gridItems.data) {
                this.gridItems.data.forEach((item, index) => {
                    this.mappingServiceDropDownData(
                        item.revenueCategoryId,
                        index
                    );
                });
            }
        });
    }

    onRevenueCategoryOpen(index: number) {
        if (index !== this.editedRowIndex) {
            if (this.serviceForm.valid) {
                this.grid.closeRow(this.editedRowIndex);
                this.editedRowIndex = index;
                this.grid.editRow(index);
            }
        }
    }

    mappingServiceDropDownData(revenueCategoryId: any, index: number) {
        if (this.serviceDataCopy) {
            if (revenueCategoryId != null) {
                return (this.gridItems.data[index].serviceTypeDataSource =
                    _.filter(this.serviceDataCopy, [
                        "revenueCategoryId",
                        revenueCategoryId,
                    ]));
            } else {
                return (this.gridItems.data[index].serviceTypeDataSource =
                    this.serviceDataCopy);
            }
        }
    }

    onAddNewService(): void {
        this.gridItems.data.splice(0, 0, this.generateNewRow());
        this.mappingServiceDropDownData(null, 0);
        this.serviceForm.form.markAsDirty();
        this.emitUpdateServices.emit();
    }

    onCellClickHandler(
        { sender, rowIndex, columnIndex, dataItem, isEdited },
        grid: any
    ) {
        if (this.editedRowIndex !== rowIndex) {
            grid.closeRow(this.editedRowIndex);
            this.editedRowIndex = rowIndex;
            sender.editRow(rowIndex);
            this.emitUpdateServices.emit();
        }
    }

    onServiceChange(event: any, dataItem: any, index: number) {
        this.onResetHandler(dataItem);
        dataItem.serviceName = event.serviceName;
        dataItem.isChanged = true;
        dataItem.revenueCategoryId = event.revenueCategoryId;
        this.mappingServiceDropDownData(dataItem.revenueCategoryId, index);
        this.servicesApiService
            .getCalculatedCost(event.serviceId)
            .subscribe((response) => {
                if (this.orderData.createdDate && this.orderData.newTaxConfigAppliedDate) {
                    const createdDate = new Date(this.orderData.createdDate);
                    const newTaxConfigAppliedDate = new Date(this.orderData.newTaxConfigAppliedDate);
                    if(newTaxConfigAppliedDate >= createdDate){
                        response.data.total = response.data.total - response.data.tax;
                    }
                }
                this.commonService.objectMapping(dataItem, response.data);
                const serviceName =
                    dataItem && dataItem.serviceName
                        ? dataItem.serviceName.trim().toLowerCase()
                        : "";
                if (
                    serviceName.indexOf("pickup") !== -1 &&
                    !dataItem.isPickupQuantityChanged
                ) {
                    dataItem.quantity = this.fromDistance
                        ? Math.ceil(this.fromDistance * 2)
                        : dataItem.quantity;
                    this.onCalulateServiceRow(dataItem);
                } else {
                    this.onCalculateTotals();
                }
            });
    }

    onDescChange(dataItem: any) {
        dataItem.isChanged = true;
    }

    onRevenueCategoryChange(event: any, dataItem: any, index: number) {
        // If the revenue category is changed, then the service should be reset
        this.commonService.objectMapping(dataItem, this.generateNewRow());
        dataItem.isChanged = true;
        this.mappingServiceDropDownData(event.revenueCategoryId, index);
    }

    generateNewRow(): any {
        // each time we create a service, to avoid same reference to all service
        return Object.assign({}, this.commmonDataModel.serviceListObjectModel);
    }

    onRemoveHandler(rowIndex: number) {
        this.commonService
            .getConfirmationPopup(`You want to remove the service ?`)
            .then((result) => {
                if (result) {
                    this.gridItems.data.splice(rowIndex, 1);
                    this.serviceForm.form.markAsDirty();
                    this.onCalculateTotals();
                }
            });
    }

    removeGridRecords(isOrigin: boolean) {
        this.gridItems.data = this.gridItems.data.filter(
            (item) => item.categoryId === (isOrigin ? 2 : 1)
        );
    }

    onQuantityChange(dataItem: any, fromReset?: boolean) {
        dataItem.isChanged = true;
        if (fromReset) {
            dataItem.isPickupQuantityChanged = false;
            dataItem.quantity = this.frenchiseDistaceQty;
            this.commonService.setLocalStorage("isPickupModified", false);
            this.commonService.setLocalStorage("pickupQty", -1);
            this.checkCalculation(dataItem);
        } else {
            dataItem.quantity = dataItem.quantity ? +dataItem.quantity : 0;
            this.checkCalculation(dataItem);
            if (dataItem.serviceName.trim().toLowerCase() === "pickup") {
                dataItem.isPickupQuantityChanged = true;
                this.commonService.setLocalStorage("isPickupModified", true);
                this.commonService.setLocalStorage(
                    "pickupQty",
                    dataItem.quantity
                );
            }
        }
    }

    onCostChange(dataItem: any) {
        dataItem.cost = dataItem.cost ? +dataItem.cost : 0;
        dataItem.isChanged = true;
        this.calculateSubTotal(dataItem);
        this.calculateMarkup(dataItem);
        this.calculateTotal(dataItem);
        this.calculateMarginPercentage(dataItem);
        this.onCalculateTotals();
    }

    onTaxableChange(dataItem: any, event: any) {
        let taxedAmount = 0;
        if (event.checked && dataItem.taxPercentage) {
            taxedAmount = parseFloat(((dataItem.taxPercentage * parseFloat(dataItem.total)) / 100).toFixed(2));
            dataItem.total = (taxedAmount + dataItem.total).toFixed(2);
            dataItem.tax = taxedAmount;
            this.commonMethod.sendIsTaxable(event.checked);
        } else {
            dataItem.total = parseFloat((parseFloat(dataItem.total) - parseFloat(dataItem.tax)).toFixed(2));
            dataItem.tax = taxedAmount;
            const allUnchecked = this.gridItems.data.every(item => !item.isTaxable);
            this.commonMethod.sendIsTaxable(!allUnchecked);
        }
        this.serviceForm.form.markAsDirty();
        this.onCalculateTotals();
    }

    onCalculateTotals() {
        if (this.gridItems.data) {
            const getTotalSubTotal = this.gridItems.data
                .filter((item) => item.subTotal)
                .map((x) => x.subTotal);
            this.totalSubTotal = getTotalSubTotal.length
                ? getTotalSubTotal.reduce((a, b) => +a + +b)
                : 0;
            const getTotal = this.gridItems.data
                .filter((item) => item.total)
                .map((x) => x.total);
            this.totalValue = getTotal.length
                ? getTotal.reduce((a, b) => +a + +b)
                : 0;
            this.commonMethod.sendIsTaxTotal(this.totalValue);
            const getTaxTotal = this.gridItems.data
                .filter((item) => item.tax)
                .map((x) => x.tax);
            this.taxTotal = getTaxTotal.length
                ? getTaxTotal.reduce((a, b) => +a + +b)
                : 0;
            this.commonMethod.sendIsTaxValue(this.taxTotal);
            const getMarkupTotal = this.gridItems.data
                .filter((item) => item.markUp)
                .map((x) => x.markUp);
            this.markUpTotal = getMarkupTotal.length
                ? getMarkupTotal.reduce((a, b) => +a + +b)
                : 0;
            this.emitUpdateServices.emit();
        }
    }

    onMarkupPercentageChange(dataItem: any) {
        dataItem.markupPercentage = dataItem.markupPercentage
            ? +dataItem.markupPercentage
            : 0;
        dataItem.isChanged = true;
        this.calculateMarginPercentage(dataItem);
        this.calculateMarkup(dataItem);
        this.calculateTotal(dataItem);
        this.onCalculateTotals();
    }

    onMarginPercentageChange(dataItem: any) {
        dataItem.marginPercentage = dataItem.marginPercentage
            ? +dataItem.marginPercentage
            : 0;
        dataItem.isChanged = true;
        this.calculateSubTotal(dataItem);
        let total =
            (-100 * dataItem.subTotal) / (dataItem.marginPercentage - 100);
        dataItem.markUp = dataItem.total - dataItem.subTotal;
        this.calculateMarkupPercentage(dataItem);
        let taxedAmount = (total * dataItem.taxPercentage) / 100;
        if (total > 0) {
            if (dataItem.isTaxable) {
                total = total + taxedAmount;
            } else {
                taxedAmount = 0;
            }
            dataItem.total = total.toFixed(2);
        }
        dataItem.tax = taxedAmount;
    }

    onTotalChange(dataItem: any, event: any) {
        if (event) {
            this.onQuantityChange(dataItem, false);
            dataItem.total = +event;
            if (dataItem.total > 0) {
                dataItem.markUp = (dataItem.total - +dataItem.subTotal).toFixed(
                    2
                );
            }
            if (dataItem.total) {
                if (dataItem.isTaxable) {
                    const subTotal =
                        (dataItem.quantity ? +dataItem.quantity : 0) *
                        (dataItem.cost ? +dataItem.cost : 0);
                    dataItem.subTotal = subTotal.toFixed(2);
                    dataItem.tax = parseFloat(((dataItem.total || 0) - (dataItem.subTotal || 0)).toFixed(2));
                } else {
                    const subTotal =
                        (dataItem.quantity ? +dataItem.quantity : 0) *
                        (dataItem.cost ? +dataItem.cost : 0);
                    dataItem.subTotal = subTotal.toFixed(2);
                }
            }
            if (dataItem.markUp > 0) {
                dataItem.marginPercentage = (
                    (dataItem.markUp / dataItem.total) *
                    100
                ).toFixed(2);
            }
            this.calculateMarkupPercentage(dataItem);
            this.onCalculateTotals();
        }
    }

    calculateSubTotal(dataItem: any) {
        const subTotal =
            (dataItem.quantity ? +dataItem.quantity : 0) *
            (dataItem.cost ? +dataItem.cost : 0);
        dataItem.subTotal = subTotal.toFixed(2);
        this.onCalculateTotals();
    }

    calculateMarkupPercentage(dataItem: any) {
        if (!+dataItem.subTotal) {
            dataItem.markupPercentage = 0;
        } else {
            const markupPercentage =
                ((dataItem.markUp ? +dataItem.markUp : 0) /
                    (dataItem.subTotal ? +dataItem.subTotal : 0)) *
                100;
            dataItem.markupPercentage = markupPercentage.toFixed(2);
        }
        this.emitUpdateServices.emit();
    }

    calculateMarkup(dataItem: any) {
        const markupValue =
            ((dataItem.markupPercentage ? +dataItem.markupPercentage : 0) /
                100) *
            (dataItem.subTotal ? +dataItem.subTotal : 0);
        dataItem.markUp = markupValue.toFixed(2);
    }

    calculateMarginPercentage(dataItem: any) {
        const cost = dataItem.cost ? +dataItem.cost : 0;
        const markupPercentage = dataItem.markupPercentage
            ? +dataItem.markupPercentage
            : 0;
        if (cost > 0) {
            const marginPerValue =
                ((cost + (cost * markupPercentage) / 100 - cost) /
                    (cost + (cost * markupPercentage) / 100)) *
                100;
            dataItem.marginPercentage = marginPerValue.toFixed(2);
        }
    }

    calculateTotal(dataItem: any, noModification = false) {
        dataItem.total =
            (dataItem.markUp ? +dataItem.markUp : 0) +
            (dataItem.subTotal ? +dataItem.subTotal : 0);
        let taxedAmount = parseFloat(((dataItem.taxPercentage * parseFloat(dataItem.total)) / 100).toFixed(2));
        if (dataItem.isTaxable) {
            dataItem.total += taxedAmount;
            dataItem.tax = taxedAmount;
        } else {
            dataItem.tax = 0;
        }
    }

    onReomveDefaultService(addressType: number) {
        if (addressType === 1) {
            this.gridItems.data = this.gridItems.data.filter(
                (service) => !service.byAccount || service.categoryId != 1
            );
        } else if (addressType === 2) {
            this.gridItems.data = this.gridItems.data.filter(
                (service) => !service.byAccount || service.categoryId != 2
            );
        }
    }

    handleFilter(value: any, dataItem: any) {
        const results =
            dataItem.revenueCategoryId == null
                ? this.serviceDataCopy
                : _.filter(this.serviceDataCopy, [
                    "revenueCategoryId",
                    dataItem.revenueCategoryId,
                ]);

        return (dataItem.serviceTypeDataSource = results.filter(
            (s) =>
                s.serviceName
                    .trim()
                    .toLowerCase()
                    .indexOf(value.toLowerCase()) !== -1 ||
                (s.revenueCategoryName &&
                    s.revenueCategoryName
                        .trim()
                        .toLowerCase()
                        .indexOf(value.toLowerCase()) !== -1)
        ));
    }

    onResetHandler(dataItem: any) {
        this.serviceForm.form.markAsDirty();
        this.onQuantityChange(dataItem, true);
    }

    checkCalculation(dataItem: any) {
        this.calculateSubTotal(dataItem);
        this.calculateMarkup(dataItem);
        this.calculateTotal(dataItem);
        this.onCalculateTotals();
    }

    ngOnDestroy() {
        this.commonService.setLocalStorage("isPickupModified", false);
        this.commonService.setLocalStorage("pickupQty", -1);
        this.componentSubscriptions.unsubscribe();
    }
}
